(function () {
    'use strict';
    angular
        .module('setupApp')
        .constant('POL_RELATION_CONSTANT', {
           'poRelation': [{
        		code:'PO',name: 'PO'
            },{
            	code:'LA',name:'LA'
            },{
            	code:'BN',name:'BN'}]        	
        });
})();
